"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Builder = _interopRequireDefault(require("../../components/Builder"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var BuilderConnect = function BuilderConnect(props) {
  return /*#__PURE__*/_react["default"].createElement(_Builder["default"], _extends({}, props, {
    flowId: props.match.params.flowId,
    showGoBackLink: true
  }));
};
BuilderConnect.propTypes = {
  match: _propTypes["default"].object
};
var _default = exports["default"] = BuilderConnect;